export default __webpack_public_path__ + "static/media/GreenSlant.a1fa49fc.svg";